import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackV2PageView } from '../services/tracking';

/** Scroll window to top on v2 route or query changes. */
export default function V2ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  useEffect(() => {
    trackV2PageView({ path: pathname + search });
  }, [pathname, search]);

  return null;
}
